import { getCDNDomain, getPDFDomain } from '@umu/umu-util';
import { isDingding, isIos, isUMUWebview } from '@umu/umu-ua';
import { _system } from '@umu/ukit-lang';
import { $window } from '@umu/umu-dom';

export const getPdfJs = () => {
    const cdnDomain = getCDNDomain();
    const pdfDomain = getPDFDomain();
    if (/quark|sogou|ucbrowser/.test(navigator.userAgent.toLowerCase()) || isDingding) {
        // return "http://m.dev12.umucdn.cn/statics/course/cn/pdf/dingding_ios.js";
        if (isIos) {
            // use 2.8 version
            return `${cdnDomain}/common/legacy/pdf.min.js`;
        }

        return `${pdfDomain}/statics/js/pdf/pdf.min.2.12.js`;
    }

    return `${pdfDomain}/statics/js/pdf/pdf.min.2.12.js`;
};

export const getPdfJsWorker = () => {
    const cdnDomain = getCDNDomain();
    const pdfDomain = getPDFDomain();

    const compatibleVersionPDFJS = `${pdfDomain}/statics/js/pdf/pdf.worker.min.2.12.dingding_221024.js`;

    // 针对VivoY30使用和钉钉AndroidApp内相同的pdf worker js
    // VIVO Y30 UserAgent
    // Mozilla/5.0 (Linux; U; Android 9; zh-CN; V1901A Build/QP1A.190711.020) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/69.0.3497.100 UWS/3.22.1.161 Mobile Safari/537.36 AliApp(DingTalk/6.3.7) com.alibaba.android.rimet/15291578 Channel/10006337 language/zh-CN UT4Aplus/0.2.25 colorScheme/light
    const lowercaseUserAgent = navigator.userAgent.toLowerCase();
    const isVivoY30 = lowercaseUserAgent.includes('v1901a build') && lowercaseUserAgent.includes('android 9');

    if (isVivoY30 && isUMUWebview) {
        return compatibleVersionPDFJS;
    }

    if (/quark|sogou|ucbrowser/.test(lowercaseUserAgent) || isDingding) {
        if (isIos) {
            // use 2.8 version
            return `${cdnDomain}/common/legacy/pdf.worker.min.js`;
        }

        return compatibleVersionPDFJS;
    }

    return `${pdfDomain}/statics/js/pdf/pdf.worker.min.2.12.js`;
};

const getJPConfig = () => {
    let enterprisesForEnableSvg: number[] = [];
    enterprisesForEnableSvg = [1371 /** 测试环境 凯江 */];


    return enterprisesForEnableSvg;
};

const getCNConfig = () => {
    let enterprisesForEnableSvg: number[] = [];

    enterprisesForEnableSvg = [45 /** 测试环境 umu052501 */];

    return enterprisesForEnableSvg;
};

/**
 * 测试企业id，45启用svg
 * @param userInfo
 */
export function isEnableSvgRender(userInfo?: IUserInfo) {
    let enterprisesForEnableSvg: number[] = [];
    let currentEnterpriseId = 0;
    let isSvgRender = false;


    enterprisesForEnableSvg = getJPConfig();

    if (!userInfo) {
        return isSvgRender;
    }

    currentEnterpriseId = Number(userInfo.enterprise_id);
    isSvgRender =
        enterprisesForEnableSvg.filter((id) => {
            return id === currentEnterpriseId;
        }).length > 0;

    return isSvgRender;
}

export function isNumber(value: number) {
    return typeof value === 'number';
}

export const getPixelRatio = () => {
    // ios16，devicePixelRatio为3，当放大2时，Canvas的尺寸超出最大值，导致canvas渲染异常
    return isIos ? 2 : $window?.devicePixelRatio || 2;
};
